import React, { useContext, useEffect, useRef, useState } from "react";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { FormattedMessage } from "react-intl";
import { PreviousLives } from "./PreviousLives";
import { DomestikaContext } from "../../../../DomestikaContext";
import When from "../../../../common/When";

export const PreviousLivesGroup = () => {
  const domain = useContext(DomestikaContext);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const categoriesRef = useRef(null);

  const loadCategories = async () => {
    const [error, data] = await domain.GetCategoriesCourseUseCase.execute();
    setLoading(false);

    if (error || !data?.categories?.length) {
      return;
    }

    setCategories(data.categories);
  };

  const getCategoriesRef = (node) => {
    if (node !== null && !categoriesRef.current) {
      categoriesRef.current = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            categoriesRef.current.disconnect();
            loadCategories();
          }
        },
        {
          rootMargin: "200px",
        }
      );
      categoriesRef.current.observe(node);
    }
  };

  useEffect(() => {
    return () => {
      if (categoriesRef.current) {
        categoriesRef.current.disconnect();
      }
    };
  }, []);

  return (
    <When condition={loading || !!categories.length}>
      {() => (
        <Flex
          flexDirection="column"
          alignItems="center"
          borderTop="1px solid"
          borderColor="durian"
          marginTop={8}
          ref={getCategoriesRef}
        >
          <Flex width={["100%", "100%", "928px", "1200px"]} paddingLeft={[4, 5, 0, "10px"]}>
            <Text as="h2" size="huge" fontWeight="medium" marginTop={8}>
              <FormattedMessage id="live_sessions.landing.previous_live_sessions" />
            </Text>
          </Flex>
          {categories.map((category) => (
            <PreviousLives key={`dmstk-live-previous-live-${category.id}`} category={category} />
          ))}
        </Flex>
      )}
    </When>
  );
};

export default PreviousLivesGroup;
